<template>
  
  <div>
    <div class="Top002639">
        <header class="header auto clearfix ycenter">
            <div class="header-left">
                <a href="https://www.yzhospital.cn/">
                  <img src="@/assets/u4.png">
                </a>
            </div>
            
            <div class="header-right">
                <div class="header-top clearfix">
                  <dl>
                    <!-- <dt style="">
                      <input type="text"  :value="searchValue"  style="width:100%;background:none;height: 39px;border: none;outline: none;">
                      <a class="btn" :href="'https://www.yzhospital.cn/TheResultOfSearch/list.aspx?searchKey=' + searchValue" ></a>
                    </dt> -->
                    <!-- <dd class="code">
                      <a-popover trigger="hover">
                        <template #content>
                          <img src="https://www.yzhospital.cn/uploadfiles/2021/05/20210506152057044.png?5b6u5L+h5oiq5Zu+XzIwMjEwNTA2MTUxODQwLnBuZw==" alt="" style="width: 150px;height: 150px;">
                        </template>
                        <img src="https://www.yzhospital.cn/cn/images/Top002639_icon_wx.png" alt="" style="width: 22px;height: 20px;">
                      </a-popover>
                    </dd> -->
                    {{$store.loginStatus}}
                    <dd class="Login" v-if="!$store.state.loginStatus">
                      <div  @click="LoginJump(0)">
                        登录
                      </div>
                      <div @click="LoginJump(1)">
                        注册
                      </div>
                    </dd>
                    <dd class="user" style="padding: 8px 0px 0 8px" v-if="$store.state.loginStatus">
                      
                      <a-popover trigger="hover">
                        <template #content>
                          <div style="background:#fff;box-shadow: 0 2px 8px rgb(0 0 0 / 15%);padding: 10px;">
                            <a-button type="primary" style="background: #007d6f;border-color: #007d6f;" @click="out()">
                            退出
                          </a-button>
                          </div>
                         
                        </template>
                        您好：{{$store.state.login.userName}}
                      </a-popover>
                    </dd>
                    <dd id="open_menu" :class="{'open_menu_on':minMenu}" @click="minMenu = !minMenu">
                      <i></i>
                    </dd>
                  </dl>
                </div>
                <!-- <div class="header-menu">
                  <template>
                    <div id="components-dropdown-demo-placement">
                      <template v-for="(item, index) in menuList">
                        <a-popover placement="bottom" trigger="hover">
                          <template slot="content">
                            <p class="header-menu-item" v-for="(items,indexs) in item.children" :key="items.text" @click="routerPath(items,item)">
                              <span class="menu-item">{{items.text}}</span>
                              
                              外面放开来，这边要注释
                              <a class="menu-item" rel="noopener noreferrer" :href="'https://www.yzhospital.cn'+ items.url"
                                v-if="items.url"
                                >{{items.text}}</a>
                                <router-link  class="menu-item" rel="noopener noreferrer" :to="items.path"
                                  v-if="items.path">
                                  {{items.text}}
                                </router-link>
                            </p>
                          
                          </template>
                          
                          <div class="top_menu_btn">
                            <a rel="noopener noreferrer" :href="'https://www.yzhospital.cn'+item.url">
                              {{item.text}}
                            </a>  
                            
                          </div>
                        </a-popover>
                      
                      </template>
                    </div>
                  </template>
                </div> -->

            </div>
        </header>
        
        <a-drawer
        
          placement="left"
          :closable="false"
          :mask="false"
          :maskClosable="false"
          :visible="minMenu"
          @close="onClose"
        >
          <div class="left-Menu" v-for="(item,index) in menuList" :key="item.text">
            <div>
              <div>
                <a rel="noopener noreferrer" :href="'https://www.yzhospital.cn'+item.url">
                  {{item.text}}
                </a>
              </div>
              <div :class="{'opRight-btn':true,'opRight-btn_on':leftMenuIndex == index}" v-if="item.children" @click="changeMenuIndex(index)"></div>
            </div>
            <transition name='fave'>
              <div class="sub" v-if="item.children && leftMenuIndex == index">
                <div  v-for="(items,indexs) in item.children" :key="items.text" @click="routerPath(items,item)" >
                  {{items.text}}
                  <!-- <a :href="'https://www.yzhospital.cn'+ items.url"
                    v-if="items.url"
                    >{{items.text}}</a>
                  <router-link :to="items.path"
                    v-if="items.path">
                    {{items.text}}
                  </router-link> -->
                </div>
              </div>
            </transition>
            
          </div>
        
        </a-drawer>
    </div>
    <!-- <div class="Banner002291">
      <img src="https://www.yzhospital.cn/uploadfiles/banner/20210402102410902.jpg" alt="">
    </div> -->

    <a-modal 
    v-model="Loginvisible"  
    :footer="null"  
    :closable="false"
    :dialog-style="{ top: '20px' }"
    >
      <div class="Login-model">
        <div>
          <div>
            <a-icon type="info-circle" :style="{ color: '#448ef7',fontSize: '27px' }"/>
            <span>温馨提示</span>
          </div>
          <p>请先登录</p>
        </div>
        <div>
          <div>
            <img src="@/assets/u3.svg" alt="" style="width: 100%;opacity: 0.2;">
            <div class="login-box">
              <img src="@/assets/u1.png" alt="" class="closeIcon" @click="closeLogin">
              <div>
                <img src="@/assets/u4.png" alt="">
                <LoginForm ref="LoginForm" @handleOk="FullHandleOk" @handlebye="closeLogin"></LoginForm>
               
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
    </a-modal>
  </div>
</template>
<script>
import LoginForm from '@/components/form/loginForm.vue'
export default {
  name: 'heder',
  components:{
    LoginForm
  },
  data () {
    return {
      searchValue: '',
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      minMenu:false,
      menuList:[
        {
          text:'首  页',
          url:'/index.aspx',
        },
        {
          text:'医院概况',
          url:'/HospitalIntroduction/index.aspx',
          children:[
            {
              text:'医院简介',
              url:'/HospitalIntroduction/index.aspx'
            },
            {
              text:'领导团队',
              url:'/LeadingTeams/index.aspx'
            },
            {
              text:'组织架构',
              url:'/organization/index.aspx'
            },
            {
              text:'医院文化',
              url:'/HospitalIdentify/index.aspx'
            },
            {
              text:'地理交通',
              url:'/AboutTraffic/index.aspx'
            },
            {
              text:'联系我们',
              url:'/ContactUs/index.aspx'
            }
          ]
        },
        {
          text:'党建引领',
          url:'/Trends/list.aspx',
          children:[
            {
              text:'党建动态',
              url:'/Trends/list.aspx'
            },
            {
              text:'统一战线',
              url:'/UnitedFront/list.aspx'
            },
            {
              text:'意识形态学习',
              url:'/StudyScope/list.aspx'
            },
            {
              text:'清风廉政',
              url:'/Wind/list.aspx'
            },
            {
              text:'职工之家',
              url:'/StaffHome/list.aspx'
            },
            {
              text:'青年园地',
              url:'/YouthGarden/list.aspx'
            },
            {
              text:'志愿服务',
              url:'/VolunteerServiceChildren1/list.aspx'
            }
          ]
        },
        {
          text:'新闻中心',
          url:'/HospitalDynamic/list.aspx',
          children:[
            {
              text:'医院动态',
              url:'/HospitalDynamic/list.aspx'
            },
            {
              text:'媒体之声',
              url:'/Media/list.aspx'
            }
          ]
        },
        {
          text:'医疗护理',
          url:'/Departments/list.aspx',
          children:[
            {
              text:'科室介绍',
              url:'/Departments/list.aspx'
            },
            {
              text:'专家介绍',
              url:'/IntroductionByAnExpert/list.aspx?lcid=56'
            },
            {
              text:'医务之窗',
              url:'/MedicalStaff/list.aspx'
            },
            {
              text:'护理园地',
              url:'/CareDynamics/list.aspx'
            },
            {
              text:'院感防控',
              url:'/Prevention/list.aspx'
            }
          ]
        },
        {
          text:'教学科研',
          url:'/Works/list.aspx',
          children:[
            {
              text:'教育',
              url:'/Works/list.aspx'
            },
            {
              text:'科研',
              url:'/Achievements/list.aspx'
            },
            {
              text:'伦理委员会',
              url:'/EthicsCommittee/list.aspx'
            },
            {
              text:'常用链接',
              url:'/Links/list.aspx'
            },
            {
              text:'图书馆',
              url:'#'
            }
          ]
        },
        {
          text:'就医服务',
          url:'/ExpertClinic/index.aspx',
          children:[
            {
              text:'专家门诊',
              url:'/ExpertClinic/index.aspx'
            },
            {
              text:'便民服务',
              url:'/PeopleService/index.aspx'
            },
            {
              text:'就医攻略',
              url:'/TreatmentStrategy/list.aspx'
            },
            {
              text:'住院须知',
              url:'/AdmissionGuide/list.aspx'
            },
            {
              text:'医保须知',
              url:'/MedicareInfo/list.aspx'
            },
            {
              text:'健康宣教',
              url:'/HealthPromotion/list.aspx'
            },
            {
              text:'监督投诉',
              url:'/jdts/index.aspx'
            }
          ]
        },
        {
          text:'人力资源',
          url:'/TalentRecruitment/list.aspx',
          key:"sub1",
          children:[
            {
              text:'人才招聘',
              url:'/TalentRecruitment/list.aspx'
            },
            {
              text:'在线应聘',
              key:"applyFor",
              path:'/applyFor'
            }
          ]
        },
      ],
      leftMenuIndex:null,
      Loginvisible:false,
      
    }
  },
  watch: {
    windowWidth (val) {
      if(this.windowWidth > 1024){
        this.minMenu = false
      }else{
        this.minMenu = false
      }
    }
  },
  mounted(){
    var that = this;

    if(this.$util.getLocalFun('yzsygwUser')){
      this.$store.commit('update', JSON.parse(this.$util.getLocalFun('yzsygwUser')) )
    }
   
        // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = window.fullWidth; // 宽
      })()
    };
   
    if(window.location.pathname == '/applyFor' && !this.$store.state.loginStatus){
      this.Loginvisible = true
    }

  },
  methods:{
    onClose() {
      this.minMenu = false;
    },
    changeMenuIndex(index){
      if(this.leftMenuIndex === index){
        this.leftMenuIndex = null
      }else{
        this.leftMenuIndex = index
      }
    },
    routerPath(data,e){
 
      let path
      if(data.url){
        path = 'https://www.yzhospital.cn'+ data.url
        window.location = path
      }else if(data.path){
        if(data.path == window.location.pathname){

        }else{
          path = data.path
          this.$router.push(path)
        }
      }      
    },
    LoginJump(e){
      if(e == 0){
        this.Loginvisible = true
      }else if(e == 1){
        this.$router.push('/register')
        // this.$router.push({name:'register'})
      }
    },
    closeLogin(){
      // 关闭后清空form
      this.Loginvisible = false
      this.$refs.LoginForm.handleReset();
    },
    async FullHandleOk(data){
  
      const res = await this.$api.login(data)
      // console.log(res)
      if(res.code == '0'){
      
        this.$store.commit('update', res.data)
        this.$util.setLocalFun('yzsygwUser',JSON.stringify(res.data))
        // this.closeLogin()
        location.reload()
      }else if(res.code == '-1'){
        // this.$store.state.isChangeNum = false
        this.$store.state.isChangeNum = true
        // console.log(this.$store.state)
      }
      
    },
    out(){
      this.$util.removeLocalFun('yzsygwUser')
      this.$store.state.login = {}
      this.$store.state.loginStatus = false
      location.reload()
    }
  }
}
</script>

<style lang="less" scoped >
  /deep/.ant-drawer-body{
    padding: 0;
  }
  /deep/.ant-popover-arrow{
    display: none !important;
  }
  /deep/.ant-drawer-content-wrapper{
    width: 60vw !important;
    max-width: 240px !important
  }
  /deep/.ant-drawer-wrapper-body{
    background: @mainBg;
  }
  /deep/.ant-modal-content{
    background-color:transparent ;
    box-shadow: none;
  }
  .header-menu-item{
    position: relative;
    background:@mainBg;
    padding: 1px 0;
    line-height: 40px;
    width:104px;
    // top: -100px;
    border-bottom: 1px dotted @bottom-color;
    >.menu-item{
        
        text-align: center;
        color: #fff;
        font-size: 15px;  
        display: block;
        cursor:pointer;
    }
    >.menu-item:hover{
      color: #bdd9db;
    }
  } 

 
  .auto {
    margin: 0 auto;
  }
  .ycenter {
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
  }

  .Top002639 {
    background: #fff;
  
    .auto {
      max-width: 1280px;
    }
    .header-left {
      width: 35%;
      img{
        display: block;
        width: 100%;
        max-width: 385px;
      }
    }

    .header-right {
      width: 65%;
      padding-top: 13px;
      .header-top {
        dl{
          float: right;
        }
        dl> * {
          float: left;
        }
        dt{
        border-bottom: 1px solid #ddd;
        position: relative;
        width: 350px;
          .btn{
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 40px;
            background: url(https://www.yzhospital.cn/cn/images/Top002639_icon_search.png) no-repeat right center;
          }
        }
        .code {
          margin: 9px 0 0 22px;
          position: relative;
          z-index: 100;
        }
      }
    
      .header-menu{
        .top_menu_btn{
          display: inline-block;
          width: 12.5%;
          text-align: center;
          line-height:40px;
          font-size: 16px;
          text-align: center;
          color: @main-color;
          font-weight: bold;
          margin:10px 0 15px 0;
      
          >a{
            color: @main-color;
         
          }
        }
        .ant-dropdown-menu-item-active{
          position: relative;
          background: @mainBg !important;
          padding: 5px;
          >a{
            border-bottom: 1px dotted @bottom-color!important;
            text-align: center;
            color: #fff !important;
            font-size: 15px !important;
            display: block !important;
            position: relative;
            background: @mainBg !important;
            padding: 5px !important;
          }
        }
        .header-menu-item{
          position: relative;
          background: @mainBg;
          padding: 5px;
          >.menu-item{
            border-bottom: 1px dotted @bottom-color !important;
            text-align: center;
            color: #fff !important;
            font-size: 15px !important;
            display: block !important;
            position: relative;
            background: @mainBg !important;
            padding: 5px !important;
            
          }
        } 
      
      }
      img {
        display: block;
        width: 100%;
        max-width: 385px;
      }
    }
 
  }

 


  #components-dropdown-demo-placement .ant-btn {
    margin-right: 8px;
    margin-bottom: 8px;
  }


  @media (max-width: 1400px){
    .Top002639 {
      padding: 0 2%;
    }
  }
  @media (max-width: 1200px){
    .top_menu_btn {
      font-size: 14px !important;
    }
  }
  @media (max-width: 1024px){
    .Top002639 {
      position: relative;
      z-index: 100;
      .header-menu{
        display: none;
      }
      .header-right {
        padding: 10px 0;
      }
      #open_menu{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #cfebef;
        margin-left: 10px;
        position: relative;
      }
      #open_menu i {
          width: 60%;
          left: 20%;
          height: 3px;
          margin-top: -1.5px;
          top: 50%;
      }
     
      
      #open_menu i, #open_menu i::before, #open_menu i::after {
          position: absolute;
          background: @mainBg;
      }
      #open_menu i::before {
          top: 6px;
      }
      #open_menu i::after {
          top: -6px;
      }
      #open_menu i::before, #open_menu i::after {
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        transition: transform 0.3s;
      }
      .open_menu_on i {
          background: none !important;
      }
      .open_menu_on i::before {
          transform: rotate(45deg);
      }
      .open_menu_on i::after {
          transform: rotate(-45deg);
      }
      .open_menu_on i::before,.open_menu_on i::after {
          top: 0 !important;
      }
     
    }
    
  }

  @media (max-width: 920px){
    .Top002639 {
        padding-bottom: 40px;
        dt{
          position: absolute !important;
          left: 0;
          width: 100% !important;
          bottom: 0;
          padding: 0 2%;
          background: #f9f9f9;
        }
    }
  }
 
  @media (max-width: 768px){
    .Top002639 .header-left, .Top002639 .header-right {
        width: 50%;
    }
  }
  .left-Menu{
   
    a{
      color: #fff;
    }
    >div:nth-child(1){
      color: #fff;
      border-bottom: 1px solid rgba(255,255,255,0.3);
      font-weight: bold;
      line-height: 40px;
      font-size: 16px;
      background: @mainBg;
      position: relative;
      >div:nth-child(1){
        border-bottom: 1px solid rgba(0,0,0,0.3);
        padding: 0 0 0 30px;
        
      }
      .opRight-btn{
        width: 15px;
        height: 15px;
        position: absolute;
        right: 3%;
        top: 50%;
        margin-top: -7px;
      }
      .opRight-btn::before {
        width: 100%;
        height: 3px;
        top: 6px;
        background: #fff;
        position: absolute;
        content: '';
      }
      .opRight-btn::after {
        width: 3px;
        left: 6px;
        top: 0;
        height: 100%;
        background: #fff;
        position: absolute;
        content: '';
      }
      .opRight-btn_on{
        transform: rotate(45deg); 
        transition: transform 0.3s;
      }
    }
    >div:nth-child(2){
      background: @mainBg;
      color: #fff;
      >div{
        background: @mainBg;
        line-height: 40px;
        padding:0 10px 0 30px;
        border-bottom: 1px dashed rgba(0,0,0,0.5);
        cursor:pointer;
      }
    }
  }
  .left-Menu:last-child{
    border: none;
    >div:first-child{
      border: none;
      >div:first-child{
        border: none;
      }
    }
  }
  .fave-enter,.fave-leave-to{
    height: 0px;
  }
  .fave-enter-active,.fave-leave-active{
    transition: all 500ms ease-in; /* 缓动 */
    background: @mainBg;
    overflow: hidden;
  }
  .fave-enter-to,.fave-leave{
    height:200px;
  }

  .Banner002291{
    overflow: hidden;
    background: #fcfcfc;
    text-align: center;
    >img{
      width: 155%;
      margin-left: -27.5%;
    }
   
    
    @media only screen and (min-width: 768px){
      img{
        width: 150%;
        margin-left:-25%;
      }
      
    }
    @media only screen and (min-width: 1024px){
      img{
        width: 140%;
        margin-left: -20%;
      }
    }
    @media only screen and (min-width: 1280px){
      img{
        height: 300px;
        width: 1280px;
        margin: 0;
      }
    }
  }
  .Login{
    display: flex;
    margin: 3px 0px 0 10px;
    background: @mainBg;
    color: #fff;
    padding: 8px 10px;
    border-radius: 5px;
    font-size: 15px;
    line-height: 12px;
    >div:nth-child(1){
      padding-right: 5px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    >div:nth-child(2){
      padding-left: 5px;
      cursor: pointer;
    }
  }
  .Login-model{
    width: 606px;
    >div:nth-child(1){
      background: #e6f7ff;
      border: 1px solid #91d5ff;
      padding: 16px;
      border-radius: 5px;
      position: relative;
      text-align: center;
      color: rgba(0, 0, 0, 0.427450980392157);
      font-size: 14px;
      >div:nth-child(1){
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        top:13px;
        >span{
          margin-left: 10px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.647058823529412);
        }
      }
    }
    >div:nth-child(2){
      background-color: rgba(255, 255, 255, 1);
      margin-top: 20px;
      border-radius: 7px;
      >div{
         background-color: rgba(0, 125, 111, 0.101960784313725);
     
         position: relative;
      }
      
    }
  }

  .login-box{
    position: absolute;
    top: 10px;
    width: 100%;
    padding: 20px 20px 0;
    .closeIcon{
      position: absolute;
      right: 12px;
      top: 0px;
    }
    >div:nth-child(2){
      text-align: center;
      >img{
        max-width: 385px;
        width: 100%;
      }
    }
  }
</style>